module.exports = __webpack_public_path__ + "img/discount.087cc9fb.svg";